import { Box } from "@mui/material";
import type { TalentExperienceData } from "./experienceTypes";

interface VideoDisplayProps {
  data?: TalentExperienceData;
}

export default function VideoDisplay({ data = {} }: VideoDisplayProps) {
  const videoUrl = data.video?.videoUrl?.trim();
  if (!videoUrl) return null;

  return (
    <Box sx={{ bgcolor: "#0d0c0a" }}>
      <Box
        component="video"
        src={videoUrl}
        controls
        playsInline
        sx={{ width: "100%", display: "block", maxHeight: 480 }}
      />
    </Box>
  );
}
